import { useQuery } from '@tanstack/react-query'
import { api, ApiError } from '@/lib/api'

export interface CurrentUser {
  id: number
  email: string
  full_name: string | null
  // Matches the DB chk_user_type constraint. Today every signup is a 'patient';
  // 'doctor' is the legacy default that still routes to the workflow UI. There
  // is no 'clinician'/'admin' role.
  user_type: 'doctor' | 'patient' | null
}

interface CurrentUserResponse {
  authenticated: boolean
  user?: CurrentUser
}

export function useCurrentUser() {
  return useQuery({
    queryKey: ['current-user'],
    queryFn: async () => {
      try {
        const res = await api.get<CurrentUserResponse>('/api/current-user')
        return res.authenticated ? res.user ?? null : null
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null
        throw err
      }
    },
  })
}
